const boostedOddsAnimation = (oddsButton) => {
  const oddsButtonRect = oddsButton.getBoundingClientRect();
  const right = window.innerWidth - oddsButtonRect.right;
  const flyingBlock = document.createElement('div');

  flyingBlock.className = 'rocket-animation';
  flyingBlock.innerHTML = `
    <div class="rocket">
      <div class="rocket-body">
        <div class="body"></div>
        <div class="fin fin-left"></div>
        <div class="fin fin-right"></div>
        <div class="window"></div>
      </div>
      <div class="exhaust-flame"></div>
      <ul class="exhaust-fumes">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  `;

  document.body.appendChild(flyingBlock);

  flyingBlock.style.right = `${right}px`;
  flyingBlock.style.top = `${oddsButtonRect.top}px`;

  const keyframes = [];
  const steps = 20;
  const endX = right - 20;
  const endY = 40 - oddsButtonRect.top;
  const maxCurveHeight = 50;

  for (let i = 0; i <= steps; i++) {
    const progress = i / steps;
    const x = endX * progress;

    const curveY = endY * progress - maxCurveHeight * Math.sin(progress * Math.PI);

    const rotationDegree = 20 * Math.sin(progress * Math.PI);

    keyframes.push({
      transform: `translate3d(${x}px, ${curveY}px, 0) rotate(${rotationDegree}deg)`,
      offset: progress,
    });
  }

  keyframes[keyframes.length - 1].easing = 'ease-in';

  const motionAnimation = flyingBlock.animate(
    keyframes,
    { duration: 1000 },
  );

  motionAnimation.onfinish = () => {
    flyingBlock.remove();
  };
};

export default boostedOddsAnimation;
